import { get } from 'svelte/store'

import { analytics } from '@lib/mixpanel/mixpanel'
import { PassportEvents, dispatch } from '@lib/events/events'
import { userStore, isLoggedInStore, accessTokenStore, isLoggingInProcessStore } from '@packages/stores'
import { PassportLocalStorage } from '@packages/utils/enums'

import { sdk } from '@lib/sdk/sdk'
import { AUTH_PROVIDERS } from '@packages/utils/enums'
import { Passport } from '@src/Passport'
import { getAddress } from './blockchain'
import { configStore } from '@src/stores/config'
import { providerStore } from '@src/stores'
import { EVM_LOGIN_SCOPE } from '@src/constants/auth-scopes'

export async function login(
  this: Passport,
  provider: AUTH_PROVIDERS,
  {
    forceEmail,
    forcePhone,
  }: {
    forceEmail?: string
    forcePhone?: string
  } = {},
) {
  void analytics.track('cp_login_initiated', {
    chain: this.config.chainId,
    clientId: this.config.clientId,
    provider: provider,
    location: window.location.origin + window.location.pathname,
  })

  try {
    if (provider === AUTH_PROVIDERS.EVM) {
      await sdk.evm.loginWithSignature()
    } else if (provider === AUTH_PROVIDERS.OAUTH) {
      await sdk.oauth.loginWithRedirect({
        scope: EVM_LOGIN_SCOPE,
        redirectUrl: window.location.href,
        ...(forceEmail && { forceEmail }),
        ...(forcePhone && { forcePhone }),
      })
    } else {
      throw new Error('Unknown provider')
    }
    this.init()
  } catch (err) {
    dispatch(PassportEvents.ERROR, { provider, error: err })
    throw err
  }
}

export async function setAccessToken(this: Passport, accessToken: string) {
  try {
    isLoggingInProcessStore.set(true)
    accessTokenStore.set(accessToken)
    await sdk.oauth.setAccessToken(accessToken)
    this.init()
  } catch (err) {
    dispatch(PassportEvents.ERROR, { provider: 'ACCESS_TOKEN', error: err })
    throw err
  } finally {
    isLoggingInProcessStore.set(false)
  }
}

export async function logout({ shouldRevokeSession = false } = {}) {
  try {
    const config = get(configStore)
    const user = get(userStore)
    analytics.track('cp_logout', {
      chain: config.chainId,
      clientId: config.clientId,
      address: await getAddress(),
      location: window.location.href,
      $email: user?.email,
      $phone: user?.phone,
    })
  } catch {
    /**/
  }

  localStorage.removeItem(PassportLocalStorage.QR_CODE)
  isLoggedInStore.set(false)
  providerStore.set(null)
  userStore.set(null)
  accessTokenStore.set(null)
  if (shouldRevokeSession) {
    await sdk.oauth.revokeSession()
  }
  sdk.logout()
  dispatch(PassportEvents.LOGOUT)
}
